import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import HighlightUnpavedRoads from '../../../tests/list/highlightUnpavedRoads';
// import UpdateUnpavedRoadsAfterReverse from '../../../tests/list/updateUnpavedRoadsAfterReverse';

// const getTestedComponent = (pos, callback) => {
//   const testedComponentList = [
//     <HighlightUnpavedRoads completed={callback} />,
//     <UpdateUnpavedRoadsAfterReverse completed={callback} />,
//   ];
//   return testedComponentList[pos];
// };

const TestLauncher = () => {
  const { authentication = {} } = useSelector((store) => store);
  const { isLoggedIn, user = {} } = authentication;
  const { email } = user;

  const [isTestUser, setTestUserStatus] = useState(false);
  //   const [pos, setPos] = useState(0);

  //   const testCompleted = () => {
  //     console.info('DONE');
  //     setPos(pos + 1);
  //   };

  useEffect(() => {
    if (email === 'test@test.test') {
      setTestUserStatus(true);
    }
  }, [email, isLoggedIn]);

  if (isTestUser) {
    return <>{/* {getTestedComponent(pos, testCompleted)} */}</>;
  }
  return '';
};

export default TestLauncher;
